import { getLocationName, Location } from 'entities-next/common'
import { isArray } from 'lodash'
import React, { useCallback } from 'react'
import { AutoComplete, AutoCompleteProps } from 'scenes/Dashboard/components/Inputs/Select'
import {
  AutoCompleteDataType,
  AutoCompleteOption,
} from 'scenes/Dashboard/components/Inputs/Select/AutoComplete/AutoComplete.model'
import { FieldProps } from 'utils-next/forms'

export type LocationSelectProps = Omit<AutoCompleteProps, 'value' | 'dataType' | 'onCreateOption' | 'onChange'> &
  FieldProps & { locationFieldName: string }
export function CriteriaLocationSelect({
  field: { name, value },
  form: { setFieldValue },
  isMulti,
  locationFieldName,
  ...asyncSelectProps
}: LocationSelectProps) {
  const handleChange = useCallback(
    (autoCompleteOption: AutoCompleteOption | '') => {
      if (!autoCompleteOption) {
        setFieldValue(name, undefined)
        return
      }
      if (isArray(autoCompleteOption)) {
        const values = autoCompleteOption.map((option) => {
          return option.value
        })
        setFieldValue(`${name}.${locationFieldName}`, values)
      }
    },
    [`${name}.${locationFieldName}`, setFieldValue]
  )
  let values
  if (value) {
    values = value.locations.map((location: Location) =>
      location ? { value: location, display: { label: getLocationName(location) } } : undefined
    )
  }

  return (
    <AutoComplete
      dataType={AutoCompleteDataType.locations}
      onChange={handleChange}
      isMulti={isMulti}
      value={values}
      isClearable
      name={name}
      {...asyncSelectProps}
    />
  )
}
